import axios from "axios";
import {RetrieveUserInformation} from "services/User/user.service";

export const tariffsAPI = axios.create({
  baseURL: import.meta.env.VITE_TARIFFS_API,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

tariffsAPI.interceptors.request.use(async (config) => {
  const token: string | undefined =
    RetrieveUserInformation()?.accessToken ?? "";

  if (token) {
    config.headers = config.headers ?? {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

let tariffsRequestInterceptorId: number | null = null;

export const handleTariffsRequestInterceptor = (token: string) => {
  if (token) {
    tariffsAPI.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete tariffsAPI.defaults.headers.common.Authorization;
  }

  if (tariffsRequestInterceptorId !== null) {
    return tariffsRequestInterceptorId;
  }

  tariffsRequestInterceptorId = tariffsAPI.interceptors.request.use(
    async (config) => {
      const authHeader =
        (tariffsAPI.defaults.headers.common.Authorization as
          | string
          | undefined) ?? "";

      if (authHeader) {
        config.headers = config.headers ?? {};
        if (!config.headers.Authorization) {
          config.headers.Authorization = authHeader;
        }
      }
      return config;
    },
  );

  return tariffsRequestInterceptorId;
};
